import styled from "styled-components";
export const WeekPaperContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
